module.exports = __webpack_public_path__ + "img/icn_redo.444d7b5a.svg";